import { create } from 'zustand';

type RightDrawerStore = {
  closeRequestId: number;
  requestClose: () => void;
};

export const useRightDrawerStore = create<RightDrawerStore>((set) => ({
  closeRequestId: 0,
  requestClose: () => set((state) => ({ closeRequestId: state.closeRequestId + 1 })),
}));

export const closeRightDrawer = (): void => {
  useRightDrawerStore.getState().requestClose();
};
